import { createSlice, createSelector } from "@reduxjs/toolkit";
import { coreApi } from "api/core";
import { setShowMessage } from "redux/slices/uiSlice";

const baseUrl = "/account-permissions";

const initialState = {
  item: {},
  loading: false,
  timestamp: null,
};

const accountPermissionsSlice = createSlice({
  name: "accountPermissions",
  initialState,
  reducers: {
    setAccountPermissions: (state, action) => {
      state.item = action.payload;
      state.timestamp = +new Date();
    },
    setAccountPermissionsLoading: (state) => {
      state.loading = true;
    },
    setAccountPermissionsReady: (state) => {
      state.loading = false;
    },
  },
});
export const {
  setAccountPermissions,
  setAccountPermissionsLoading,
  setAccountPermissionsReady,
} = accountPermissionsSlice.actions;

export default accountPermissionsSlice.reducer;

export const getAccountPermissions = () => async (dispatch) => {
  dispatch(setAccountPermissionsLoading());
  try {
    const data = await coreApi.fetch(baseUrl);
    dispatch(setAccountPermissions(data));
  } catch (err) {
    console.error("Failed to fetch account permissions:", err);
  } finally {
    dispatch(setAccountPermissionsReady());
  }
};

export const addAccountPermission = (payload) => async (dispatch) => {
  dispatch(setAccountPermissionsLoading());
  try {
    await coreApi.post(baseUrl, payload);
    dispatch(setShowMessage({ type: "success", description: "Account permission added successfully" }));
    dispatch(getAccountPermissions());
  } catch (err) {
    dispatch(setShowMessage({ type: "error", description: "Failed to add account permission" }));
  } finally {
    dispatch(setAccountPermissionsReady());
  }
};

export const updateAccountPermission = (payload) => async (dispatch) => {
  dispatch(setAccountPermissionsLoading());
  try {
    const accountPermission = await coreApi.put(baseUrl, payload);
    dispatch(setShowMessage({ type: "success", description: "Account permission updated successfully" }));
    dispatch(getAccountPermissions());
    return accountPermission;
  } catch (err) {
    dispatch(setShowMessage({ type: "error", description: "Failed to update account permission" }));
  } finally {
    dispatch(setAccountPermissionsReady());
  }
};

const loadingSelector = ({ accountPermissions }) => accountPermissions?.loading;
const accountPermissionSelector = ({ accountPermissions }) => accountPermissions?.item || {};

export const selectAccountPermission = createSelector(accountPermissionSelector, (data) => data);

export const selectAccountPermissionsStatus = createSelector(loadingSelector, (loading) => loading);
